import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import './i18n';
import './styles/global.css';
import { App } from './app/App';
import { avviaDaUrl } from './app/simulatore';

registerSW({ immediate: true });

// Un link dal banco di prova (`www.emacomfort.com`)
// porta l'impianto nella query e punta all'area da guardare. Va letto PRIMA
// del primo render: il cancello di accesso e `DeviceProvider` decidono su
// questa modalita' mentre montano. Inerte su un host installatore, e su
// qualsiasi URL che non porti una configurazione.
avviaDaUrl(window.location);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
